import axios from 'axios';
import { useAuthStore, useAppStore, useAppErrorStore } from '@/stores'
import { version as app_version } from '../../package.json';
import router from '@/router';

let API_BASE_URL

switch (import.meta.env.MODE) {
  case 'development':
    // API_BASE_URL = 'http://localhost:3000/'
    // API_BASE_URL = import.meta.env.VITE_APP_API_URL
    API_BASE_URL = 'https://trmg.dev/api/v1/'
    break
  case 'production':
    API_BASE_URL = 'https://app.therightmovegroup.com/api/v1/'
    break
  case 'staging':
    API_BASE_URL = 'https://beta.therightmovegroup.com/api/v1/'
    break
}
// console.log('API_BASE_URL', API_BASE_URL, import.meta.env)

const api = {
  get: request('GET'),
  post: request('POST'),
  put: request('PUT'),
  patch: request('PATCH'),
  delete: request('DELETE'),
};

const customAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    // 'Content-Type': 'application/json',
    'Accept': 'text/javascript, application/javascript, application/x-ecmascript, */*; q=0.01',
    'X-Requested-With': 'XMLHttpRequest',
    'X-App-Version': app_version,
    // See Olive Branch gem for use of the Key-Inflection header
    // -  this gem allows us to use camelCase for JSON responses
    'Key-Inflection': 'camel',    
  },
})

customAxios.interceptors.response.use(undefined, (error) => {
  if (error && error.response && !error.response.config.url.startsWith('/auth')) {
    if (error.response.status === 401) {
      const authStore = useAuthStore();
      const appStore = useAppStore();
      const { error: err, detail } = error.response.data
      
      authStore.logout();
      appStore.notify({
        severity: "error",
        summary: error,
        detail: detail,
        life: 5000
      })
      router.replace({ path: '/login' })
    }

    if (error.response.status === 422) {
      const appStore = useAppStore();
      appStore.notify({
        severity: 'error',
        summary: error.response.data.error || error.response.data.message, 
        detail: error.response.data.detail,
        life: 5000 
      })
    }

    if (error.response.status === 403) {
      const appStore = useAppStore();
      appStore.notify({
        severity: 'error',
        summary: error.response.data.error, 
        detail: error.response.data.detail, 
        life: 5000 
      })
      return router.push('/');
    }

    if (error.response.status === 404) {
     return router.push({ name: 'not-found' });
    }

    if (error.response.status === 500) {
      const appErrorStore = useAppErrorStore()
      appErrorStore.handleApiErrorResponse(error)
     // return router.push({ name: 'internal-server-error' });
    }
  }

  return Promise.reject(error);
});

function request(method) {
  return (url, body={}, options={}) => {
    const authStore = useAuthStore();

    const requestOptions = {
      url,
      method,
      ...options,
      headers: {
        Authorization: `Bearer ${authStore.isLoggedIn ? authStore.token : null}`,
        ...options.headers,
      },
    };

    if (method == 'GET') {
      requestOptions.params = body
      requestOptions.data = {}
    } else {
      requestOptions.data = body
    }

    return customAxios(requestOptions);
  }
}

export default api;